export default "__VITE_ASSET__swXTU5Lq__"